import { inject, injectable } from "inversify";
import { Socket, io } from "socket.io-client";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import { errorFactroy } from "../../error/MadmaxError";
import { ERROR_CODES } from "../../error/errorCodes";
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";
import Wallet from "../../wallet/Wallet";
import { FETCH_TYPES } from "../Connect";
import IAjaxConnect from "../ajax/IAjaxConnect";

@injectable()
export default class ConnectSocket implements IAjaxConnect {
	protected readonly wsRegex = /ws{1,2}\:\/{2}/;
	timeout: number;

	public readonly fetchType: string = FETCH_TYPES.WEBSOCKET;
	private _config: SystemConfig;

	private _params: any;
	private _url: string;
	private _ws: Socket;
	private _wallet: Wallet;

	constructor(
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet
	) {
		this._config = config;
		this._ws = null;
		this._url = this._config.get(CONFIG_PARAMS.WEB_SOCKET);
		this._wallet = wallet;
	}

	// setSocketType(name: string) {
	// 	this.socketType = name;
	// }

	fetch(params) {
		this._params = params;

		return new Promise((res, rej) => {
			if (!this._url) {
				//due to error in TF try again to get websocket url
				this._url = this._config.get(CONFIG_PARAMS.WEB_SOCKET);
			}

			//backwards compatibility fix, new games receive url with wss:// prefix, for old games it needs to be added here
			if (!this.wsRegex.test(this._url)) {
				this._url = `wss://${this._url}`;
			}

			this._ws = io(this._url, {
				transports: ["websocket", "polling"],
			});

			this._ws.on("connect_failed", (error) => {
				//remove this listener, we will use fallback in future
				this._ws.off("connect_failed");
				this._ws.io.opts.transports = ["polling", "websocket"];
				//fallback error handler, if polling errors, kill the game.
				this._ws.on("connect_failed", (error) => {
					let madmaxError = errorFactroy({
						code: ERROR_CODES.WS_CONNECT_FAILED,
						fetchType: this.fetchType,
						msg: "WebSocket connection failed",
						error,
					});

					rej(madmaxError);
				});
			});

			this._ws.on("connect", () => {
				console.log("WS Connected");

				setTimeout(() => this._registration(this._params), 1000);

				res(this._ws);
			});

			this._ws.on("balance", this._onBalance.bind(this));
		});
	}

	on(eventName: string, cb: (data) => void) {
		this._ws.on(eventName, (data) => cb(data));
	}

	_registration({ sessionId, sessionKey, casinoId }) {
		this._ws.emit("registration", {
			sid: sessionId,
			session_key: sessionKey,
			cid: casinoId,
			consume_news: true,
		});
	}

	_onBalance(data) {
		// console.log("#ws onBalance data: ", data);

		if (!data) {
			return;
		}
		if (data.balance && this._config.get(CONFIG_PARAMS.USE_WS_BALANCE)) {
			this._wallet.refreshBalance(data.balance);
		}
		if (!this._wallet.getTotalLoss()) {
			// events.dispatch(WALLET_EVENTS.WALLET_ON_TOTAL_LOSS, {balance: data.balance, totalLoss: data.total_loss });
			this._wallet.refreshTotalLoss(data.total_loss);
			this._wallet.computeTotalLoss();
		}
	}
}
